<template src="./NavbarV2.template.html"></template>
<script>
import component from './NavbarV2.script.js';

export default component;
</script>
<style src="./NavbarV2.style.css" scoped></style>
